import { render, staticRenderFns } from "./MisExpedientes.vue?vue&type=template&id=7b27c05a&scoped=true"
import script from "./MisExpedientes.vue?vue&type=script&lang=js"
export * from "./MisExpedientes.vue?vue&type=script&lang=js"
import style0 from "./MisExpedientes.vue?vue&type=style&index=0&id=7b27c05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b27c05a",
  null
  
)

export default component.exports